import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import LandingPage from "./components/LandingPage";
import ThankYouPage from "./components/ThankYouPage";
import PaymentSuccess from "./components/PaymentSuccess";
import PaymentCancelled from "./components/PaymentCancelled";
import UpgradeSuccess from "./components/UpgradeSuccess";
import UpgradeCancelled from "./components/UpgradeCancelled";
import AdminDashboard from "./components/AdminDashboard";
import BasicMemberPortalWrapper from "./components/BasicMemberPortalWrapper";
import FAQPage from "./components/FAQPage";
import MemberSuccessStories from "./components/MemberSuccessStories";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LegacyPropertyCouncilLanding = () => {
  return (
    <div className="min-h-screen">
      <LandingPage />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LegacyPropertyCouncilLanding />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-cancelled" element={<PaymentCancelled />} />
          <Route path="/upgrade-success" element={<UpgradeSuccess />} />
          <Route path="/upgrade-cancelled" element={<UpgradeCancelled />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/basic-portal" element={<BasicMemberPortalWrapper />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/member-success-stories" element={<MemberSuccessStories />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;